import { useMemo } from 'react';
import AccentCta from '../../components/servicios/AccentCta';
import PageIndex from '../../components/servicios/PageIndex';
import RichContent from '../../components/servicios/RichContent';
import SectionTitle from '../../components/servicios/SectionTitle';
import Container from '../../components/shared/Container';
import PageHero from '../../components/shared/PageHero';
import {
  BENEFICIARIAS_BLOCKS,
  CTA_FORMULARIO_HREF,
  CTA_FORMULARIO_LABEL,
  DOCUMENTACION_BLOCKS,
  DOCUMENTACION_NOTA,
  INTRO_BLOCKS,
  PROTECCION_BLOCKS,
  RECONOCIMIENTO_BLOCKS,
  SECTIONS,
  TRAMITACION_PASOS,
} from '../../data/cataIncendios';
import { useScrollSpy } from '../../hooks/useScrollSpy';
import styles from './CataIncendiosPage.module.css';

export default function CataIncendiosPage() {
  const sectionIds = useMemo(() => SECTIONS.map((section) => section.id), []);
  const activeId = useScrollSpy(sectionIds);

  const cta = (
    <AccentCta className={styles.cta} href={CTA_FORMULARIO_HREF} icon="arrow">
      {CTA_FORMULARIO_LABEL}
    </AccentCta>
  );

  return (
    <>
      <PageHero
        image={null}
        actions={
          <a
            className={styles.heroCta}
            href={CTA_FORMULARIO_HREF}
            target="_blank"
            rel="noopener noreferrer"
          >
            {CTA_FORMULARIO_LABEL}
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </a>
        }
        breadcrumb={[
          { label: 'Inicio', to: '/' },
          { label: 'Servicios' },
          { label: 'Prestación extraordinaria CATA Incendios' },
        ]}
        title="Prestación extraordinaria por cese de actividad"
        subtitle="Para trabajadores autónomos afectados por los incendios forestales de 2026."
      />

      <Container as="section" className={styles.body}>
        <div className={styles.layout}>
          <PageIndex items={SECTIONS} activeId={activeId} />

          <div className={styles.content}>
            <section id="apoyo" className={styles.section}>
              <SectionTitle title="Apoyo para las personas trabajadoras autónomas afectadas por los incendios forestales" />
              <div className={styles.intro}>
                <RichContent blocks={INTRO_BLOCKS} />
              </div>
              {cta}
            </section>

            <section id="proteccion" className={styles.section}>
              <SectionTitle title="Una protección extraordinaria ante el cese de actividad" />
              <RichContent blocks={PROTECCION_BLOCKS} />
            </section>

            <section id="beneficiarias" className={styles.section}>
              <SectionTitle title="¿Quién puede solicitarla?" />
              <p className={styles.sectionLead}>Personas beneficiarias</p>
              <RichContent blocks={BENEFICIARIAS_BLOCKS} />
            </section>

            <section id="documentacion" className={styles.section}>
              <SectionTitle title="¿Qué documentación necesitas?" />
              <p className={styles.sectionLead}>Prepara tu solicitud</p>
              <RichContent blocks={DOCUMENTACION_BLOCKS} />
              <p className={styles.note}>
                <strong>Importante:</strong> {DOCUMENTACION_NOTA}
              </p>
            </section>

            <section id="tramitacion" className={styles.section}>
              <SectionTitle title="¿Cómo se solicita?" />
              <p className={styles.sectionLead}>Una tramitación sencilla y telemática</p>

              <ol className={styles.steps}>
                {TRAMITACION_PASOS.map((paso) => (
                  <li key={paso.numero} className={styles.step}>
                    <span className={styles.stepNumber} aria-hidden="true">
                      {paso.numero}
                    </span>
                    <div className={styles.stepBody}>
                      <h3 className={styles.stepTitle}>{paso.titulo}</h3>
                      <RichContent blocks={paso.blocks} />
                    </div>
                  </li>
                ))}
              </ol>

              {cta}
            </section>

            <section id="reconocimiento" className={`${styles.section} ${styles.sectionLast}`}>
              <SectionTitle title="Reconocimiento provisional" />
              <RichContent blocks={RECONOCIMIENTO_BLOCKS} />
            </section>
          </div>
        </div>
      </Container>
    </>
  );
}
